import { Box, CircularProgress } from "@mui/material";

export default function Loader() {
  return (
    <Box sx={{ height: "100px", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <CircularProgress color="white" />
    </Box>
  );
}
